import { useEffect, useRef, useState } from 'react';

const useInterval = ({ callback, delay, params, initial = true }) => {
    const savedCallback = useRef(null);
    // intervalState가 false이면 interval이 멈추고 true면 interval이 진행됨
    const [intervalState, setIntervalState] = useState(initial);

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // intervalState를 toggle하는 함수
    const toggleDelay = () => {
        setIntervalState(!intervalState);
    };

    useEffect(() => {
        const interval = () => {
            savedCallback.current(params);
        };

        if (intervalState) {
            const id = setInterval(interval, delay);

            return () => {
                clearInterval(id);
            };
        }
    }, [delay, intervalState]);

    return toggleDelay;
};

export default useInterval;
